<div class="modal-header bg-light">
  <h4 class="modal-title w-100 text-center">💳 Select Payment Mode</h4>
</div>

<div class="modal-body">
  <p class="text-muted mb-3">
    Total Payable:
    <strong class="clr-black">₹{{ totalAmount | number : "1.0-0" }}</strong>
  </p>

  <!-- Mode Selection -->
  <div class="d-flex justify-content-around mb-3 payment-option-wrap">
    <div
      class="payment-option"
      [class.selected]="isSelected('cash')"
      (click)="selectMode('cash')"
      >
      <img src="images/icons/cash.svg" alt="Cash" width="40" />
      <p>Cash</p>
    </div>
    <div
      class="payment-option"
      [class.selected]="isSelected('card')"
      (click)="selectMode('card')"
      >
      <img src="images/icons/card.svg" alt="Card" width="40" />
      <p>Card</p>
    </div>
    <div
      class="payment-option"
      [class.selected]="isSelected('upi')"
      (click)="selectMode('upi')"
      >
      <img src="images/icons/upi.svg" alt="UPI" width="40" />
      <p>UPI</p>
    </div>
  </div>

  <!-- Split Toggle -->
  <!-- Split Toggle -->
  <div
    class="form-check text-center mb-3 d-flex align-items-center split-payment"
    >
    <input
      type="checkbox"
      class="form-check-input"
      id="splitCheck"
      [(ngModel)]="splitEnabled"
      (change)="onSplitToggle()"
      />
      <label class="form-check-label" for="splitCheck">Split Payment?</label>
    </div>

    <!-- Payment Inputs -->
    <form [formGroup]="paymentForm">
      <div class="row split-payment-list">
        @if (isSelected('cash')) {
          <div class="col">
            <label class="payment form-check-label">Cash</label>
            <input type="number" class="form-control" formControlName="cash" />
          </div>
        }
        @if (isSelected('card')) {
          <div class="col">
            <label class="form-check-label">Card</label>
            <input type="number" class="form-control" formControlName="card" />
          </div>
        }
        @if (isSelected('upi')) {
          <div class="col">
            <label class="form-check-label">UPI</label>
            <input
              type="number"
              class="form-control"
              formControlName="upi"
              step="0.01"
              />
            </div>
          }
        </div>
      </form>
    </div>

    <div class="modal-footer justify-content-end">
      <button
        class="btn btn-outline-secondary me-2"
        (click)="activeModal.dismiss()"
        >
        Cancel
      </button>
      <button class="btn btn-success" (click)="confirm()">Confirm Payment</button>
    </div>
